import InlineIcon from "./InlineIcon.jsx";

export default function ApiStatusBadge({ label, tone = "neutral", icon = "activity" }) {
  const tones = {
    good: "border-mint/35 bg-mint/10 text-mint",
    warn: "border-gold/40 bg-gold/10 text-goldSoft",
    bad: "border-rose/40 bg-rose/10 text-rose",
    neutral: "border-white/10 bg-white/5 text-slate-200",
    info: "border-cyan/35 bg-cyan/10 text-cyan",
  };

  return (
    <span className={`inline-flex items-center gap-2 rounded-md border px-2.5 py-1 text-xs font-medium ${tones[tone]}`}>
      <InlineIcon name={icon} className="h-3.5 w-3.5" />
      {label}
    </span>
  );
}
